import Papa from 'papaparse';
import { CSVParseError } from '../errors/app-errors';
import { get } from 'svelte/store';
import { user } from '../store';

export const getCSVRecords = (csv) => {
  const parsed = Papa.parse(csv, {
    skipEmptyLines: true,
    header: true
  });

  if(parsed.errors.length === 0) {
    return removeEmptyKeys(mapToResident(parsed.data));
  } else {
    throw new CSVParseError(parsed.errors.join(", "));
  }
}

const removeEmptyKeys = (accounts) => {
  return accounts
    .map(account => {
      let cleanAccount = {};
      Object.keys(account).forEach(key => { if (account[key]) cleanAccount[key] = account[key] });
      return cleanAccount;
    });
}

const mapToResident = (accounts) => {
  return accounts.map(account => {
    return {
      account_id: get(user).account_id,
      first_name: account.FIRST_NAME,
      last_name: account.LAST_NAME,
      email_1: account.USER_EMAIL,
      cell_1: account.CELL_PHONE && account.CELL_PHONE.startsWith('1-') ? account.CELL_PHONE.slice(2) : account.CELL_PHONE,
      home_phone: account.HOME_PHONE && account.HOME_PHONE.startsWith('1-') ? account.HOME_PHONE.slice(2) : account.HOME_PHONE,
      ubmax_acc: account.BILLING_ACCOUNT,
      house_number: account.ADDRESS_NUMBER_ONE,
      street: account.STREET_NAME_ONE,
      city: account.CITY,
      state: account.STATE,
      postal_code: account.ZIP_CODE,
      property_type: account.CLASS,
      route: account.ROUTE,
      division: account.DIVISION ? account.DIVISION : 'NONE',
      well: account.WELL ? account.WELL : 'NONE',

      address_2: account.ADDRESS_LINE_TWO,
      unit: account.UNIT,
      po_box: account.PO_BOX,
      country: account.COUNTRY_NAME,
      county: account.COUNTY,
      latitude: account.GPS_LATITUDE,
      longitude: account.GPS_LONGITUDE,
      language: 'EN'
    }
  });
}